import { useState, useEffect, useRef } from 'preact/hooks';
import { createMachine, interpret } from '@xstate/fsm';
import { loadState, saveState } from '../utils/local-storage';
import { initialContext, MULTISTEP_FORM_LOCAL_STORAGE_KEY } from '../types';
export const useMultistepMachine = ()=>{
    const [contextState, setContextState] = useState(initialContext);
    const [index, setIndex] = useState(0);
    const [machineState, setMachineState] = useState('choose');
    const serviceRef = useRef(null);
    useEffect(()=>{
        const saved = loadState(MULTISTEP_FORM_LOCAL_STORAGE_KEY);
        const baseContext = saved && {
            ...initialContext,
            ...saved.context || {}
        } || initialContext;
        setContextState(baseContext);
        const validStates = [
            'choose',
            'select',
            'confirm'
        ];
        const savedState = saved === null || saved === void 0 ? void 0 : saved.state;
        const resolvedInitial = savedState && validStates.includes(savedState) ? savedState : 'choose';
        const machine = createMachine({
            id: 'multistep',
            initial: resolvedInitial,
            states: {
                choose: {
                    on: {
                        NEXT: 'select'
                    }
                },
                select: {
                    on: {
                        NEXT: 'confirm',
                        BACK: 'choose'
                    }
                },
                confirm: {
                    on: {
                        BACK: 'select'
                    }
                }
            }
        });
        const service = interpret(machine);
        serviceRef.current = service;
        const sub = service.subscribe((s)=>{
            const stepMap = {
                choose: 0,
                select: 1,
                confirm: 2
            };
            var _stepMap_s_value;
            setIndex((_stepMap_s_value = stepMap[s.value]) !== null && _stepMap_s_value !== void 0 ? _stepMap_s_value : 0);
            setMachineState(s.value);
        });
        service.start();
        return ()=>{
            var _sub_unsubscribe;
            (_sub_unsubscribe = sub.unsubscribe) === null || _sub_unsubscribe === void 0 ? void 0 : _sub_unsubscribe.call(sub);
            service.stop();
            serviceRef.current = null;
        };
    }, []);
    useEffect(()=>{
        saveState(MULTISTEP_FORM_LOCAL_STORAGE_KEY, {
            state: machineState,
            context: contextState
        });
    }, [
        contextState,
        machineState
    ]);
    return {
        index,
        machineState,
        serviceRef,
        contextState,
        setContextState
    };
};
